// extracted by mini-css-extract-plugin
export default {"wrapper":"Features_wrapper__Pii9K","title":"Features_title__EmSQT","description":"Features_description__moWMu"};